<template>
  <div class="transcription-wrapper" :class="[editing ? 'transcription-wrapper-editing' : 'transcription-wrapper-static']">
    <TranscriptionHeader v-model:editing="editing" />
    <TranscriptionList :editing="editing" />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import TranscriptionHeader from './TranscriptionHeader.vue';
import TranscriptionList from './TranscriptionList.vue';

const editing = ref(false);
</script>
<style scoped>
.transcription-wrapper {
  @apply relative flex flex-col p-4 gap-4 border rounded-10 bg-white dark:bg-zinc-900;
}

.transcription-wrapper-editing {
  @apply border-blue-500/30 ring ring-blue-500/30;
}

.transcription-wrapper-static {
  @apply border-slate-300 dark:border-zinc-700;
}
</style>
